import type { MouseEvent } from "react";
import useEventEmitter, { type Events } from "@/hooks/use-event-emitter.ts";
import Button, { type ButtonProps } from "./button.tsx";

type Props<T extends keyof Events> = ButtonProps & { event: T; data: Events[T] };
export default function EventButton<T extends keyof Events>({ children, event, data, onClick, ...props }: Props<T>) {
    const eventEmitter = useEventEmitter<T>(event);

    const handleClick = (evt: MouseEvent<HTMLButtonElement>) => {
        eventEmitter(data);
        onClick?.(evt);
    };

    return (
        <Button {...props} onClick={handleClick}>
            {children}
        </Button>
    );
}
